//#region libraries
import React, { useEffect, useState } from "react";

// custom components
import { Card, CustomSpinner } from "_atoms";
import { CircleText } from "_components/molecules";

// redux
import { useSelector } from "react-redux";
import { selectGetBookingInboundStatus, selectGetBookingOutboundStatus, selectTotalCountInbound, selectTotalCountOutbound, selectTotalNoShowCountOutbound } from "_redux/slices/prm-bookings/bookings-count";
import { selectDepPaxNoShowsFilter } from "_redux/slices/prm-bookings/calendar"
// exterior libraries
import { Block, Flex, Text, Title as TremorTitle, Metric, Bold, List, ListItem } from "@tremor/react";
import { Colors } from "_styles";

//#endregion

const BookingTotals = (props) => {
  //#region redux
  // counts / forecasting
  const bookingInboundStatus = useSelector(selectGetBookingInboundStatus);
  const bookingOutboundStatus = useSelector(selectGetBookingOutboundStatus);

  const outboundTotalCount = useSelector(selectTotalCountOutbound);
  const noShowCountOutboundTotal = useSelector(selectTotalNoShowCountOutbound);
  const inboundTotalCount = useSelector(selectTotalCountInbound);

  const depPaxNoShowsFilter = useSelector(selectDepPaxNoShowsFilter);
  //#endregion

  //#region local states
  const [loading, setLoading] = useState(true)
  const [total, setTotal] = useState(0);
  //#endregion

  //#region use effects

  //useEffect(() => {
    // log 
    //console.log("Booking Totals - outboundTotalCount:", outboundTotalCount, "inboundTotalCount:", inboundTotalCount);
  //}, [outboundTotalCount, inboundTotalCount]);

  useEffect(() => {
    if (depPaxNoShowsFilter) {
      setTotal(noShowCountOutboundTotal + inboundTotalCount);
    }
    else {
      setTotal(outboundTotalCount + inboundTotalCount);
    }
  }, [outboundTotalCount, inboundTotalCount, depPaxNoShowsFilter]);

  // loading handler
  useEffect(() => {
    if (bookingInboundStatus == 'loading' || bookingOutboundStatus == 'loading') {
      setLoading(true)
    }
    else {
      setLoading(false)
    }
  }, [bookingInboundStatus, bookingOutboundStatus,]);

  //#endregion

  return (
    <Card maxWidth="max-w-lg" shadow={true} decoration="top" decorationColor={"blue"}>
      <div>

        {/* total forecasted bookings */}
        <TremorTitle>{'Total Bookings'}</TremorTitle>

        <Block>

          {/* total counts */}
          {loading ? <CustomSpinner size={"small"} /> : <Metric>{total.toLocaleString()}</Metric>}

          {/* list headers */}
          <Flex marginTop="mt-3">
            <Text><Bold>{"Type"}</Bold></Text>
            <Text><Bold>{"Total"}</Bold></Text>
          </Flex>

          {/* list */}
          <List>
            <ListItem>
              <Flex>
                {/* <Text truncate={true}>{"Departures"}</Text> */}
                <CircleText
                  value={"Departures"}
                  color={Colors.PRM_LIGHT_BLUE}
                  textColor={"white"}
                  type="outbound"
                  inverted={true}
                  isLoading={bookingOutboundStatus == 'loading'}
                />
                <Text>{loading ? <CustomSpinner size={"small"} /> : <>{depPaxNoShowsFilter ? noShowCountOutboundTotal.toLocaleString() : outboundTotalCount.toLocaleString()}</>}</Text>
              </Flex>
            </ListItem>
            <ListItem>
              <Flex>
                {/* <Text truncate={true}>{"Arrivals"}</Text> */}
                <CircleText
                  value={"Arrivals"}
                  color={"green"}
                  textColor={"white"}
                  type="inbound"
                  inverted={true}
                  isLoading={bookingInboundStatus == 'loading'}
                />
                <Text>{loading ? <CustomSpinner size={"small"} /> : <>{inboundTotalCount.toLocaleString()}</>}</Text>
              </Flex>
            </ListItem>
          </List>

        </Block>

      </div>
    </Card>
  );
};

export default BookingTotals;
